<template>
  <div class="flex justify-center h-screen w-screen overflow-hidden">
    <!-- Row -->
    <div class="w-full xl:w-4/4 lg:w-12/12 flex">
      <!-- Col -->
      <div class="w-full lg:w-1/2 bg-white p-5 ">
        <div class="flex h-screen">
          <div class="m-auto">
            <div class="text-left " v-if="!registered">
                  <!-- <div class="flex">
                    <img class="object-contain h-12 mb-2  bounce-top-icons" src="@/assets/tap-logo.png">
                  </div> -->
                  <div class=" right-0 left-0 flex justify-center p-0 mb-4">
                     <p class="font-bold text-xl fade-in">Login to Tap Web</p>
                  </div>

                  <form action="">
                      <div class="mt-4 slide-in-bottom-subtitle">
                          <div class="">
                            Email Address
                              <input type="email" placeholder="Email"
                                  class="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"
                                  v-model="email">
                              <span class="text-xs tracking-wide text-red-600"></span>
                          </div>
                          <div class="flex items-baseline justify-between">
                              <button v-on:click="register"
                                      class="px-6 py-2 mt-4 text-white bg-blue-600 rounded-lg hover:bg-blue-900 w-full"
                                      :class="disabledClass"
                                      :disabled="isActive">
                                      {{registerBtn}}
                              </button>
                          </div>

                          <div class="flex items-center my-4">
                            <hr class="flex-grow border-gray-300">
                            <span class="px-3 text-sm text-gray-400">or</span>
                            <hr class="flex-grow border-gray-300">
                          </div>

                          <GoogleSsoComp />
                          <AppleSsoComp />
                          <MicrosoftSsoComp />

                      </div>

                            
                  </form>
                  
            </div>

            <div class="text-left" v-if="registered">
                  <div class="flex">
                    <img class="object-contain h-12 mb-2" src="@/assets/tap-logo.png">
                  </div>
                  <h2 class="font-bold text-3xl">Authentication</h2>
                  <p class="text-sm">We've sent you an OTP. Please check your inbox<br> sent to <strong>{{registered_email}}</strong></p>
                  <form action="">
                      <div class="mt-5">
                          <div>
                            <p class="text-sm font-bold">Enter your OTP</p>

                            <div class="">
                              <input type="text" placeholder=""
                                  class="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"
                                  v-on:input="codeChange($event)"
                                  v-model="code"
                                  ref="codeInput"
                                  style="text-align: center;">
                              <span class="text-xs tracking-wide text-red-600"></span>
                            </div>


                            <!-- <div id="otp" class="flex flex-row justify-center text-center px-2 mt-5"> 
                              <input class="m-2 border h-10 w-10 text-center form-control rounded" type="text" v-model="code1" v-on:input="codeChange($event)" id="first"  ref="first"  maxlength="1" autocomplete="false"/> 
                              <input class="m-2 border h-10 w-10 text-center form-control rounded" type="text" v-model="code2" v-on:input="codeChange($event)" id="second" ref="second"  maxlength="1" autocomplete="false"/> 
                              <input class="m-2 border h-10 w-10 text-center form-control rounded" type="text" v-model="code3" v-on:input="codeChange($event)" id="third"  ref="third"  maxlength="1" autocomplete="false"/> 
                              <input class="m-2 border h-10 w-10 text-center form-control rounded" type="text" v-model="code4" v-on:input="codeChange($event)" id="fourth" ref="fourth"  maxlength="1" autocomplete="false"/> 
                            </div> -->

                          </div>
                          <div class="flex items-baseline">
                              <button v-on:click="verify" 
                                      class="px-6 py-2 mt-4 text-white bg-blue-600 rounded-lg hover:bg-blue-900 w-full"
                                      :class="disabledClass"
                                      :disabled="isActive">
                                      {{verifyBtn}}
                                      </button>
                          </div>

                          <div class="flex items-baseline">
                              <button v-on:click="change_email" 
                                      class="bg-white hover:bg-gray-100 text-gray-800 py-2 px-6 border border-gray-400 rounded-lg  w-full mt-3 mb-3"
                                      :class="disabledChange"
                                      :disabled="isActive">
                                      {{changeBtn}}
                                      </button>
                          </div>

                          <div class="flex items-baseline">
                            <p class="text-left text-xs">Didn't receive OTP? 
                              <a href="#" v-on:click="resend_code" class="no-underline hover:underline text-blue-500">{{resendBtn}}</a>
                            </p>
                          </div>
                      </div>
                  </form>
            </div>
          </div>
        </div>
        <div class="fixed bottom-0 left-0 p-4 z-50" >
            <a href="https://www.cloudstaff.com" class="text-sm font-bold fade-in" style="color: rgb(6, 100, 164); bottom: 40px !important; cursor: pointer;" title="Visit Cloudstaff Official Website">Cloudstaff Official Website</a> |
            <a v-on:click="login_to_admin" class="text-sm font-bold fade-in" style="color:#0664A4; bottom: 40px !important;  cursor: pointer;">Login to Tap Admin</a> |
            <a v-on:click="gotoppolicy" class="text-sm font-bold fade-in" style="color: rgb(6, 100, 164); bottom: 40px !important; cursor: pointer;">Privacy Policy</a>
                            
        </div>
      </div>
      <div
        class="w-full h-auto bg-slate-100 hidden lg:block lg:w-1/2 bg-cover "
      >
         <div
          id="carouselDarkVariant"
          class="carousel slide carousel-fade carousel-dark relative h-screen"
          data-bs-ride="carousel"
        >
          <!-- Indicators -->
          <div class="carousel-indicators absolute right-0 bottom-0 left-0 flex justify-center p-0 mb-4">
            <button
              data-bs-target="#carouselDarkVariant"
              data-bs-slide-to="0"
              class="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              data-bs-target="#carouselDarkVariant"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              data-bs-target="#carouselDarkVariant"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
            <button
              data-bs-target="#carouselDarkVariant"
              data-bs-slide-to="3"
              aria-label="Slide 4"
            ></button>
            <button
              data-bs-target="#carouselDarkVariant"
              data-bs-slide-to="4"
              aria-label="Slide 5"
            ></button>
          </div>

          <!-- Inner -->
          <div class="carousel-inner  w-full overflow-hidden ">
            <!-- Single item -->
            <div class="carousel-item active relative w-full" id="slide1">
              <div class="flex justify-center items-center h-screen">
                  <img
                    src="@/assets/welcome-cstap.png"
                    class="w-10/12"
                  />
                  <div class="carousel-caption hidden md:block absolute text-center mb-20">
                    <h5 class="text-4xl mb-5 text-blue-900">Welcome to Cloudstaff Tap</h5>
                    <p>CS Tap is used for Cloudstaff to disseminate important information to staff, 
                      10% of Cloudstaff's PC fleet has restricted access and can not access intranets 
                      and a way for cloudstaff clients to communicate defined tasks to their Cloudstaffers 
                      while they are mobile.</p>
                  </div>
              </div>
            </div>

             <div class="carousel-item relative w-full" id="slide2">
              <div class="flex justify-center items-center h-screen">
                  <img
                    src="@/assets/tile-do.png"
                    class="w-10/12"
                  />
                  <div class="carousel-caption hidden md:block absolute text-center mb-20">
                    <h5 class="text-4xl mb-5 text-blue-900">What can a Tile do?</h5>
                    <p>Generate an Email &bull; Send a SMS message &bull; Play a Youtube Clip &bull; Show location on a map &bull; Open a website &bull; Display results from an API call &bull; Post information to a website &bull; Ask the user for an input</p>
                  </div>
              </div>
            </div>

            <div class="carousel-item relative w-full" id="slide3">
              <div class="flex justify-center items-center h-screen">
                  <img
                    src="@/assets/business-cstap.png"
                    class="w-10/12"
                  />
                  <div class="carousel-caption hidden md:block absolute text-center mb-20">
                    <h5 class="text-4xl mb-5 text-blue-900">How are business using CS TAP?</h5>
                    <p>Provide information to employees via mobile phone, capture information from the employees and create a Job Ticket, and alert a manager to an incident via SMS</p>
                  </div>
              </div>
            </div>
            <div class="carousel-item relative w-full" id="slide4">
              <div class="flex justify-center items-center h-screen">
                  <img
                    src="@/assets/no-code.png"
                    class="w-10/12"
                  />
                  <div class="carousel-caption hidden md:block absolute text-center mb-20">
                    <h5 class="text-4xl mb-5 text-blue-900">Tap is a "No Code" application</h5>
                    <p>Each of the action tiles in the app are configured from a web page and the changes are instantly pushed to team members' devices.</p>
                  </div>
              </div>
            </div>

             <div class="carousel-item relative w-full" id="slide5">
              <div class="flex justify-center items-center h-screen">
                  <img
                    src="@/assets/download-tap.png"
                    class="w-10/12"
                  />
                  <div class="carousel-caption hidden md:block absolute text-center mb-20">
                    <h5 class="text-4xl mb-5 text-blue-900">CS Tap Mobile</h5>
                    <p>Keep your workforce engaged and up to date with Cloudstaff Tap for Android and IOS. You can download the mobile app version in Cloudstaff Appstore.</p>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>

</template>

<style>		
.slide-in-bottom{-webkit-animation:slide-in-bottom .5s cubic-bezier(.25,.46,.45,.94) both;animation:slide-in-bottom .5s cubic-bezier(.25,.46,.45,.94) both}
.slide-in-bottom-h1{-webkit-animation:slide-in-bottom .5s cubic-bezier(.25,.46,.45,.94) .5s both;animation:slide-in-bottom .5s cubic-bezier(.25,.46,.45,.94) .5s both}
.slide-in-bottom-subtitle{-webkit-animation:slide-in-bottom .5s cubic-bezier(.25,.46,.45,.94) .75s both;animation:slide-in-bottom .5s cubic-bezier(.25,.46,.45,.94) .75s both}
.fade-in{-webkit-animation:fade-in 1.2s cubic-bezier(.39,.575,.565,1.000) 1s both;animation:fade-in 1.2s cubic-bezier(.39,.575,.565,1.000) 1s both}
.bounce-top-icons{-webkit-animation:bounce-top .9s 1s both;animation:bounce-top .9s 1s both}

@-webkit-keyframes slide-in-bottom{0%{-webkit-transform:translateY(1000px);transform:translateY(1000px);opacity:0}100%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}}@keyframes slide-in-bottom{0%{-webkit-transform:translateY(1000px);transform:translateY(1000px);opacity:0}100%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}}
@-webkit-keyframes bounce-top{0%{-webkit-transform:translateY(-45px);transform:translateY(-45px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:1}24%{opacity:1}40%{-webkit-transform:translateY(-24px);transform:translateY(-24px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}65%{-webkit-transform:translateY(-12px);transform:translateY(-12px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}82%{-webkit-transform:translateY(-6px);transform:translateY(-6px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}93%{-webkit-transform:translateY(-4px);transform:translateY(-4px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}25%,55%,75%,87%{-webkit-transform:translateY(0);transform:translateY(0);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}100%{-webkit-transform:translateY(0);transform:translateY(0);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out;opacity:1}}@keyframes bounce-top{0%{-webkit-transform:translateY(-45px);transform:translateY(-45px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:1}24%{opacity:1}40%{-webkit-transform:translateY(-24px);transform:translateY(-24px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}65%{-webkit-transform:translateY(-12px);transform:translateY(-12px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}82%{-webkit-transform:translateY(-6px);transform:translateY(-6px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}93%{-webkit-transform:translateY(-4px);transform:translateY(-4px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}25%,55%,75%,87%{-webkit-transform:translateY(0);transform:translateY(0);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}100%{-webkit-transform:translateY(0);transform:translateY(0);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out;opacity:1}}
@-webkit-keyframes fade-in{0%{opacity:0}100%{opacity:1}}@keyframes fade-in{0%{opacity:0}100%{opacity:1}}	
</style>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import * as microsoftTeams from "@microsoft/teams-js";
import GoogleSsoComp from '@/components/GoogleSsoComp.vue';
import AppleSsoComp from '@/components/AppleSsoComp.vue';
import MicrosoftSsoComp from '@/components/MicrosoftSsoComp.vue';

export default {
components: {
  GoogleSsoComp,
  AppleSsoComp,
  MicrosoftSsoComp,
},
data: function () {
    return {
        registerBtn: "Login",
        verifyBtn: "Verify",
        resendBtn: "Resend OTP",
        changeBtn: "Change email address",
        disabledClass: "",
        disabledChange: "",
        isActive: false,
        email: "",
        errors: [],
        registered: false,
        registered_email: "",
        code1: "",
        code2: "",
        code3: "",
        code4: "",
        code: "",
        device_identifier: "TAPWEBIDENTIFIER",
        device_type: "WEB",
        device_info: "BROWSER",
        fcm_token: "7155",
        loadingMessage: 'Verifying account',
        isAuthenticated: false,
        msalInstance: null,
        ip_public: "",
        ip_location: "",
    };
},



mounted() {
    this.authenticate();

    fetch('https://ip.cloudstaff.tech/json')
    .then(response => response.json())
    .then(data => {
      this.ip_location = data.country_code + '/' + data.city_name;
      this.ip_public = data.ip;
    });

    this.device_identifier = `${this.getuseragent()}_${this.unqid()}`;
    this.device_info = this.getuseragent();
},
methods: {

      getuseragent() {
        const userAgent = navigator.userAgent;

        if (userAgent.includes("Firefox")) {
          return "FIREFOX";
        } else if (userAgent.includes("Edg")) {
          return "EDGE";
        } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
          return "OPERA"; // Check for Opera before Chrome
        } else if (userAgent.includes("Chrome")) {
          return "CHROME";
        } else if (userAgent.includes("Safari")) {
          return "SAFARI";
        } else {
          return "UNKNOWN";
        }
      },

      unqid() {
        var timestamp = Date.now();
        var randomNum = Math.floor(Math.random() * 100000); 
        var uniqueid = `${timestamp}${randomNum}`;
        return uniqueid;
      },

      authenticate() {

        microsoftTeams.authentication.getAuthToken({
          successCallback: (token) => {
            this.setToken(token);
          },
          failureCallback: (reason) => {
            console.error("Failed to get token or in web:", reason);
          }
        });
      },
      gotoppolicy(){
        window.open('/privacy-policy', '_blank');
      },
      setToken(Ttoken)
      {
        Swal.fire({
          title: 'Microsoft Teams Account Detected',
          html: '<small>Logging you in, please wait...</small>',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        setTimeout(() => {
          fetch('https://api.ipify.org?format=json')
          .then(x => x.json())
          .then(({ ip }) => {
              this.ip_public = ip;
          });

          fetch('https://ipapi.co/'+this.ip_public+"/json")
            .then(response => response.json())
            .then(data => this.ip_location = data.country_code+'/'+data.city+' - '+data.region);
        }, 2000);
        
        axios({
            method: "post",
            url: this.baseAPIURL+"/apiv3/microsoft365Callback",
            data: { 
              token: Ttoken,
              device_identifier: "MS_"+this.device_identifier,
              device_info: this.device_info,
              ip_public: this.ip_public,
              location: this.ip_location,
            },
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then(response => {
            //handle success
            Swal.close();
            if (response.data.data.result == "success") {
                    this.isActive = false; //disable the button
                    this.disabledClass = "";
                    this.disabledChange = "";
                    this.disabledResend = "";
                    this.verifyBtn = "Verify";
                    this.loadingMessage = "Loading theme";
                    
                    this.$store.dispatch('setloginMode', "MSTEAMS");

                    Swal.update({
                      html: `<small>${this.loadingMessage}</small>`,
                    });

                        var themeData = new FormData();
                        themeData.append("email", response.data.data.email);

                        axios({
                              method: "post",
                              url: this.baseAPIURL+"/apiv3/theme.json",
                              data: themeData,
                              headers: {
                                  "auth": response.data.data.token,
                                  "Content-Type": "multipart/form-data",
                              },
                          })
                          .then(themeresponse => {
                            this.$store.dispatch("verify", {
                                  "email": response.data.data.email,
                                  "token": response.data.data.token,
                                  "user_guid": response.data.data.guid,
                            });

                            this.$store.dispatch("updateNewLoad", true);

                            Swal.close();

                            this.$store.dispatch("updateTheme", themeresponse.data.theme[0].web_main_page_icon);

                            response.data.data.data.book_code.map((item, index) => {
                                  if (index === 0) {
                                      if (this.$store.getters.selected_book == ""){    
                                          this.$store.dispatch('activeBook', item.code);
                                          this.$store.dispatch('activeBookDesc', item.description);
                                          this.$store.dispatch('setPages', item.pages);
                                      }
                                        this.$store.dispatch("setBooks", item.code);
                                        this.$store.dispatch("setActiveBooks", item.code);
                                        this.$store.dispatch("setSelectedBookModDate", item.modified);
                                    }else{
                                        this.$store.dispatch("setBooks", item.code);
                                        this.$store.dispatch("setActiveBooks", item.code);
                                        this.$store.dispatch("setSelectedBookModDate", item.modified);
                                    }
                                  
                                    if (/@cloudstaff.com\s*$/.test(this.email)) {
                                        this.$store.dispatch("setCS", true);
                                    } else {
                                        this.$store.dispatch("setCS", false);
                                  }
                              }); 

                              this.$moshaToast("Welcome!", { type: "success" });
                              this.$router.push("/dashboard");
                          });    
            } else {
              Swal.fire({
                  html: '<p class="align-left consent-header"><strong>Data Processing Consent</strong></p><br><hr><br>'+
                  '<div class="align-left">I acknowledge and understand that my Personal Data as defined by the Data Privacy Act of 2012 will be collected by Cloudstaff,'+
                  'and that my Personal Data may be processed, stored, updated or disclosed by Cloudstaff for the following purpose:'+
                  '<br><br>'+
                  '<ul style="list-style-type: disc; text-align: left; margin-left: 20px;">'+
                  '<li>To be able to open an account in CS Tap and keep the account active</li>'+
                  '<li>To conduct research and analysis (through survey or polls) in order to improve customer/ guest experience/ satisfaction</li>'+
                  '<li>To respond to specific complaints, inquiries, requests, or to provide requested information</li>'+
                  '<li>To provide customer care activities, monitor our quality and security, and provide services timely and efficiently</li>'+
                  '<li>To comply with legal and regulatory requirements or obligations and</li>'+
                  '<li>To perform such other processing or disclosure that may be required under law or regulations</li>'+
                  '<li>To keep records of historical developments of the CS Tap Web</li>'+
                  '</ul><br><br>',
                  type: "info",
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  showCancelButton: true,
                  showConfirmButton:true,
                  buttonsStyling: false,
                  reverseButtons: true,
                  confirmButtonColor: '#0770B8',
                  cancelButtonColor: '#FFFFFF',
                  customClass: {
                    popup: 'w-[50%]',
                    confirmButton: 'px-6 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-900 mx-2 my-2 border border-blue-600',
                    cancelButton: 'px-6 py-2 bg-white-100 rounded-lg hover:bg-blue-900 mx-2 my-2 border border-gray-400 hover:bg-gray-100',
                  },
                  confirmButtonText:
                  'Accept',
                  cancelButtonText:
                  'Decline',
              }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    var bodyFormData = new FormData();//
                    bodyFormData.append("email_address", response.data.data.email);
                    axios({
                    method: "post",
                    url: this.baseAPIURL+"/apiv3/msRegister",
                    data: bodyFormData,
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                      })
                      .then(response => {
                          //handle success
                          if (response.data.result === "success") {
                              this.authenticate();
                          }
                      })
                        .catch(error => {
                            console.log("Error: "+ error);
                            //handle error
                            this.isActive = false; //enable the button
                            this.disabledClass = "";
                            this.registerBtn = "Login";
                            this.$moshaToast("There's an error.", { type: "danger" });
                        });
                  } else{
                    this.isActive = false; //enable the button
                    this.disabledClass = "";
                    this.registerBtn = "Log in";
                    Swal.close();
                  }
              });
           }
        }).catch( error => {
          // Handle errors
          
          Swal.close();
          console.log(error.response);
        });
      },
    login_to_admin(e) {
      e.preventDefault();
      window.location.href = this.baseAPIURL + '/login';
    },
   
    codeChange (event) {
        // if (event.inputType === "deleteContentForward" || event.inputType === "deleteContentBackward") {
        //     if (event.currentTarget.id === "second") {
        //         this.$refs.first.focus();
        //     }
        //     else if (event.currentTarget.id === "third") {
        //         this.$refs.second.focus();
        //     }
        //     else if (event.currentTarget.id === "fourth") {
        //         this.$refs.third.focus();
        //     }
        //     return event.preventDefault();
        // }
        // else {
        //     if (event.currentTarget.id === "first") {
        //         this.$refs.second.focus();
        //     }
        //     else if (event.currentTarget.id === "second") {
        //         this.$refs.third.focus();
        //     }
        //     else if (event.currentTarget.id === "third") {
        //         this.$refs.fourth.focus();
        //     }
        // }
        const input = event.target;
        const value = input.value;

        // Remove non-numeric characters
        const numericValue = value.replace(/\D/g, '');

        // Restrict input to a maximum of 8 characters
        if (numericValue.length >= 8) {
          input.value = numericValue.slice(0, 8);
          this.code = input.value;
        } else {
          input.value = numericValue;
          this.code = input.value;
        }
    },
   
    register (e) {
        e.preventDefault(); // it prevent from page reload
        this.isActive = true; //disable the button
        this.registerBtn = "Loading...";
        this.disabledClass = "opacity-50 cursor-not-allowed";
        var continueRegister = false;

        if((!this.email) || (this.validate_email(this.email) == false)){
          continueRegister  = false;
           this.isActive = false; //enable the button
           this.disabledClass = "";
           this.registerBtn = "Login";
           
           
           this.$moshaToast("Invalid email address", { type: "danger" });
        }else{
          continueRegister = true;
        }

        if(continueRegister == true){
             var bFormData = new FormData();
        bFormData.append("email", this.email);
            axios({
                method: "post",
                url: this.baseAPIURL+"/apiv3/accountstatus.json",
                data: bFormData,
                headers: {
                    "Content-Type": "multipart/form-data"
                },
            })
            .then(response => {
                        //handle success
                        if (response.data.status === "old") {
                                  var bodyFormData = new FormData();
                                  bodyFormData.append("email_address", this.email);
                                  axios({
                                      method: "post",
                                      url: this.baseAPIURL+"/apiv3/register",
                                      data: bodyFormData,
                                      headers: {
                                          "Content-Type": "multipart/form-data"
                                      },
                                  })
                                  .then(response => {
                                      //handle success
                                      if (response.data.result === "success") {
                                          this.registered = true;
                                          this.registered_email = this.email;
                                          this.isActive = false; //enable the button
                                          this.disabledClass = "";
                                          this.registerBtn = "Login";
                                          
                                          this.$moshaToast("We sent you an OTP! Check it out!", { type: "success" });
                                      } else {

                                          this.isActive = false; //enable the button
                                          this.disabledClass = "";
                                          this.registerBtn = "Log in";
                                        
                                          if (response.data.cooldown) {
                                            this.$moshaToast("Please wait " + response.data.cooldown + " before requesting a new OTP.", { type: "danger" });
                                          } else {
                                            this.$moshaToast("Invalid email address!", { type: "danger" });
                                          }
                                          
                                      }
                                  })
                                  .catch(error => {
                                      console.log("Error: "+ error);
                                      //handle error
                                      this.isActive = false; //enable the button
                                      this.disabledClass = "";
                                      this.registerBtn = "Log in";
                                      this.$moshaToast("There's an error.", { type: "danger" });
                                  });
                        }
                        else if(response.data.status === "new") {
                          Swal.fire({
                            html: '<p class="align-left consent-header"><strong>Data Processing Consent</strong></p><br><hr><br>'+
                            '<div class="align-left">I acknowledge and understand that my Personal Data as defined by the Data Privacy Act of 2012 will be collected by Cloudstaff,'+
                            'and that my Personal Data may be processed, stored, updated or disclosed by Cloudstaff for the following purpose:'+
                            '<br><br>'+
                            '<ul style="list-style-type: disc; text-align: left; margin-left: 20px;">'+
                            '<li>To be able to open an account in CS Tap and keep the account active</li>'+
                            '<li>To conduct research and analysis (through survey or polls) in order to improve customer/ guest experience/ satisfaction</li>'+
                            '<li>To respond to specific complaints, inquiries, requests, or to provide requested information</li>'+
                            '<li>To provide customer care activities, monitor our quality and security, and provide services timely and efficiently</li>'+
                            '<li>To comply with legal and regulatory requirements or obligations and</li>'+
                            '<li>To perform such other processing or disclosure that may be required under law or regulations</li>'+
                            '<li>To keep records of historical developments of the CS Tap Web</li>'+
                            '</ul><br><br>',
                            type: "info",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showCancelButton: true,
                            showConfirmButton:true,
                            buttonsStyling: false,
                            reverseButtons: true,
                            confirmButtonColor: '#0770B8',
                            cancelButtonColor: '#FFFFFF',
                            customClass: {
                              popup: 'w-[50%]',
                              confirmButton: 'px-6 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-900 mx-2 my-2 border border-blue-600',
                              cancelButton: 'px-6 py-2 bg-white-100 rounded-lg hover:bg-blue-900 mx-2 my-2 border border-gray-400 hover:bg-gray-100',
                            },
                            confirmButtonText:
                            'Accept',
                            cancelButtonText:
                            'Decline',
                        }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
                              var bodyFormData = new FormData();//
                              bodyFormData.append("email_address", this.email);
                              axios({
                              method: "post",
                              url: this.baseAPIURL+"/apiv3/register",
                              data: bodyFormData,
                              headers: {
                                  "Content-Type": "multipart/form-data"
                              },
                                })
                                .then(response => {
                                    //handle success
                                    if (response.data.result === "success") {
                                        this.registered = true;
                                        this.registered_email = this.email;
                                        this.isActive = false; //enable the button
                                        this.disabledClass = "";
                                        this.registerBtn = "Login";
                                        
                                        this.$moshaToast("We sent you an OTP! Check it out!", { type: "success" });
                                    }
                                    else {
                                        this.isActive = false; //enable the button
                                        this.disabledClass = "";
                                        this.registerBtn = "Login";
                                        this.$moshaToast("Invalid email address!", { type: "danger" });
                                    }
                                })
                                  .catch(error => {
                                      console.log("Error: "+ error);
                                      //handle error
                                      this.isActive = false; //enable the button
                                      this.disabledClass = "";
                                      this.registerBtn = "Login";
                                      this.$moshaToast("There's an error.", { type: "danger" });
                                  });
                            } else{
                              this.isActive = false; //enable the button
                              this.disabledClass = "";
                              this.registerBtn = "Log in";
                              Swal.close();
                            }
                        });  
                }
            })
            .catch(error => {
                console.log("Error: "+ error);
                //handle error
            });
        }

     
    },
    checkCode() {
      const numericValue = this.code.replace(/\D/g, ''); // Remove non-numeric characters


      if (numericValue.length < 4 || numericValue.length > 8) {
        var error = "Code must be between 4 and 8 numeric characters.";
        this.$moshaToast(error, { type: "danger" });

        this.isActive = false; //disable the button
        this.disabledClass = "";
        this.disabledChange = "";
        this.disabledResend = "";
        this.verifyBtn = "Verify";

        return false;

      } else if (!/^\d+$/.test(numericValue)) {
        error = "Code must contain only numeric characters.";
        this.$moshaToast(error, { type: "danger" });

        this.isActive = false; //disable the button
        this.disabledClass = "";
        this.disabledChange = "";
        this.disabledResend = "";
        this.verifyBtn = "Verify";

        return false;

      } else {
        return true;
      }
    },

    verify (e) {
      e.preventDefault(); // it prevent from page reload
        this.isActive = true; //disable the button
        this.disabledClass = "opacity-50 cursor-not-allowed";
        this.disabledChange = "opacity-50 cursor-not-allowed";
        this.verifyBtn = "Loading...";
        this.disabledResend = "bg-grey-200 text-white opacity-50 cursor-not-allowed";
        // this.code = this.code1 + this.code2 + this.code3 + this.code4;

        if (this.checkCode()) {
          Swal.fire({
                      title: 'Please wait...',
                      html: `<small>${this.loadingMessage}</small>`,
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      showConfirmButton: false,
                      didOpen: () => {
                        Swal.showLoading();
                      },
          });


        var bodyFormData = new FormData();

        bodyFormData.append('code', this.code);
        bodyFormData.append('email', this.email);
        bodyFormData.append('device_identifier', this.device_identifier);
        bodyFormData.append('device_info', this.device_info);
        bodyFormData.append('device_type', this.device_type);
        bodyFormData.append('fcm_token', this.fcm_token);
        bodyFormData.append('location', this.ip_location);
        bodyFormData.append('ip_public', this.ip_public);


        axios ({
                method: "post",
                url: this.baseAPIURL+"/apiv3/confirm.json",
                data: bodyFormData,
                headers: { 
                  "Content-Type": "multipart/form-data",
                },
              })
              .then(confirm_response => {
                if (confirm_response.data.result == "success") {
                    this.isActive = false; //disable the button
                    this.disabledClass = "";
                    this.disabledChange = "";
                    this.disabledResend = "";
                    this.verifyBtn = "Verify";
                    this.loadingMessage = "Loading theme and sorting your books";
                    Swal.update({
                      html: `<small>${this.loadingMessage}</small>`,
                    });
                    Swal.showLoading();

                        if (confirm_response.data.data.book_code == null) {
                            this.$moshaToast("You do not have any active books in your account. Please reach out to administrator.", { type: "danger" });
                            this.registered = false;
                            this.code = "";
                        } else {

                          var themeData = new FormData();
                          themeData.append("email", this.email);

                          axios({
                              method: "post",
                              url: this.baseAPIURL+"/apiv3/theme.json",
                              data: themeData,
                              headers: {
                                  "auth": confirm_response.data.token,
                                  "Content-Type": "multipart/form-data",
                              },
                          })
                          .then(themeresponse => {
                            axios({
                                method: "get",
                                url: this.baseAPIURL + "/apiv3/getDomainSort.json",
                                headers: {
                                    "auth": confirm_response.data.token,
                                    "Content-Type": "multipart/form-data",
                                },
                            })
                            .then(response => {
                                let responseData = response.data;

                                try {
                                    var preload_books_sorted = [];

                                    // Extract as objects
                                    var domain_auto = responseData.data.domain_auto || {};
                                    var default_books_map = responseData.data.default || {};
                                    var book_objects = confirm_response.data.data.book_code;

                                    // Sort orders (IDs)
                                    var domain_book_sorts = Object.values(responseData.data.domain_book_sorts || {});
                                    var default_book_sorts = Object.values(responseData.data.default_book_sorts || {});

                                    // Map domain IDs → codes
                                    domain_book_sorts.forEach(id => {
                                        let code = domain_auto[id];
                                        if (code && !preload_books_sorted.includes(code)) {
                                            preload_books_sorted.push(code);
                                        }
                                    });

                                    // Map default IDs → codes
                                    default_book_sorts.forEach(id => {
                                        let code = default_books_map[id];
                                        if (code && !preload_books_sorted.includes(code)) {
                                            preload_books_sorted.push(code);
                                        }
                                    });

                                    // Reorder actual book objects
                                    const reorderedBooks = [
                                        // Items from preload_books_sorted in order
                                        ...preload_books_sorted
                                            .map(code => book_objects.find(book => book.code === code))
                                            .filter(Boolean),
                                        // Remaining items not in preload_books_sorted
                                        ...book_objects.filter(book => !preload_books_sorted.includes(book.code))
                                    ];

                                    // Loop through reordered books
                                    reorderedBooks.map((item, index) => {
                                        if (index === 0) {
                                            if (this.$store.getters.selected_book == "") {    
                                                this.$store.dispatch('activeBook', item.code);
                                                this.$store.dispatch('activeBookDesc', item.description);
                                                this.$store.dispatch('setPages', item.pages);
                                            }
                                            this.$store.dispatch("setBooks", item.code);
                                            this.$store.dispatch("setActiveBooks", item.code);
                                            this.$store.dispatch("setSelectedBookModDate", item.modified);
                                        } else {
                                            this.$store.dispatch("setBooks", item.code);
                                            this.$store.dispatch("setActiveBooks", item.code);
                                            this.$store.dispatch("setSelectedBookModDate", item.modified);
                                        }
                                      
                                        if (/@cloudstaff.com\s*$/.test(this.email)) {
                                            this.$store.dispatch("setCS", true);
                                        } else {
                                            this.$store.dispatch("setCS", false);
                                        }
                                    });

                                    // FINALIZE AND ENTER DASHBOARD
                                    Swal.close();
                                    this.$store.dispatch("verify", {
                                        "email": this.email,
                                        "token": confirm_response.data.token,
                                        "user_guid": confirm_response.data.user_guid,
                                    });

                                    this.$store.dispatch("updateNewLoad", true);
                                    this.$store.dispatch('setloginMode', "BROWSER");
                                    this.$store.dispatch("updateTheme", themeresponse.data.theme[0].web_main_page_icon);

                                    this.$moshaToast("Welcome!", { type: "success" });
                                    this.$router.push("/dashboard");

                                } catch (error) {
                                    console.error("Error parsing JSON:", error.message);
                                }
                            });

                            });

                    }
                }else{
                    Swal.close();
                    this.isActive = false; //disable the button
                    this.disabledClass = "";
                    this.disabledChange = "";
                    this.disabledResend = "";
                    this.verifyBtn = "Verify";
                    this.$moshaToast("Oops! Incorrect OTP, check your input or resend an OTP!", { type: "danger" });
                }
              
          })
          .catch(response => {
            console.log("ERROR VERIFY RESPONSE: "+response);
          });
        }
    },

    
    resend_code (e) {
        e.preventDefault(); // it prevent from page reload
        var bodyFormData = new FormData();
        bodyFormData.append("email_address", this.email);
        this.isActive = true; //disable the button
        this.disabledClass = "opacity-50 cursor-not-allowed";
        this.resendBtn = "Sending...";
        this.disabledChange = "opacity-50 cursor-not-allowed";
        axios({
            method: "post",
            url: this.baseAPIURL+"/apiv3/resendcode.json",
            data: bodyFormData,
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then(response => {
            //handle success
            if (response.data.result === "success") {
              this.isActive = false; //disable the button
              this.disabledClass = "";
              this.disabledChange = "";
              this.code = "";
              this.resendBtn = "Resend OTP";
              this.$moshaToast("We resend an OTP! Check it out.", { type: "success" });
            } else {
              this.isActive = false; //disable the button
              this.disabledClass = "";
              this.disabledChange = "";
              this.code = "";
              this.resendBtn = "Resend OTP";

              if (response.data.cooldown) {
                this.$moshaToast("Please wait " + response.data.cooldown + " before requesting a new OTP.", { type: "danger" });
              } else {
                this.$moshaToast("Resend code failed!", { type: "danger" });
              }
            }
        })
        .catch(error => {
            //handle error
            console.log(error);
            this.resendBtn = "Resend OTP";
            this.$moshaToast("Oops! Something went wrong.", { type: "danger" });
        });
    },
    change_email (e) {
        e.preventDefault();
        this.registered = false;
        this.email = "";
        this.registered_email = "";
        this.code = "";
        // this.code1 = "";
        // this.code2 = "";
        // this.code3 = "";
        // this.code4 = "";
    },

    validate_email(email){
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    },

},
watch: {
  registered(newValue) {
    if (newValue) {
      // When registered becomes true, focus on the input element
      this.$nextTick(() => {
        this.$refs.codeInput.focus();
      });
    }
  },
},
}

</script>